import React from "react";
import EnrollmentList from "../../../components/enrollments/EnrollmentList";

export default () => <EnrollmentList role="MANAGER" />;
